import { useIdioma } from '../../context/IdiomaContext';

import './AvisoLegal.css';

function AvisoLegal() {
  const { t } = useIdioma();

  const condicionesUso = t(
    'avisoLegal.condiciones.parrafos'
  );

  const propiedadIntelectual = t(
    'avisoLegal.propiedad.parrafos'
  );

  const responsabilidad = t(
    'avisoLegal.responsabilidad.parrafos'
  );

  return (
    <main className="pagina-legal">
      <article className="legal-contenido">
        <header className="legal-encabezado">
          <p className="legal-etiqueta">
            {t('avisoLegal.etiqueta')}
          </p>

          <h1>
            {t('avisoLegal.titulo')}
          </h1>

          <p>
            {t(
              'avisoLegal.ultimaActualizacion'
            )}
          </p>
        </header>

        <section>
          <h2>
            {t(
              'avisoLegal.identificacion.titulo'
            )}
          </h2>

          <p>
            {t(
              'avisoLegal.identificacion.descripcion'
            )}
          </p>

          <ul>
            <li>
              <strong>
                {t(
                  'avisoLegal.identificacion.titular'
                )}
                :
              </strong>{' '}
              José Manuel Martín Corvillo
            </li>

            <li>
              <strong>
                {t(
                  'avisoLegal.identificacion.nif'
                )}
                :
              </strong>{' '}
              44517403Y
            </li>

            <li>
              <strong>
                {t(
                  'avisoLegal.identificacion.domicilio'
                )}
                :
              </strong>{' '}
              C/ Ibiza 23, 6, 46024 Valencia,
              España
            </li>

            <li>
              <strong>
                {t(
                  'avisoLegal.identificacion.email'
                )}
                :
              </strong>{' '}

              <a href="mailto:contacto@jmmartinlabs.com">
                contacto@jmmartinlabs.com
              </a>
            </li>

            <li>
              <strong>
                {t(
                  'avisoLegal.identificacion.web'
                )}
                :
              </strong>{' '}

              <a href="https://jmmartinlabs.com/">
                jmmartinlabs.com
              </a>
            </li>
          </ul>
        </section>

        <section>
          <h2>
            {t('avisoLegal.objeto.titulo')}
          </h2>

          <p>
            {t(
              'avisoLegal.objeto.descripcion'
            )}
          </p>
        </section>

        <section>
          <h2>
            {t(
              'avisoLegal.condiciones.titulo'
            )}
          </h2>

          {condicionesUso.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </section>

        <section>
          <h2>
            {t(
              'avisoLegal.propiedad.titulo'
            )}
          </h2>

          {propiedadIntelectual.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </section>

        <section>
          <h2>
            {t(
              'avisoLegal.responsabilidad.titulo'
            )}
          </h2>

          {responsabilidad.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </section>

        <section>
          <h2>
            {t(
              'avisoLegal.enlaces.titulo'
            )}
          </h2>

          <p>
            {t(
              'avisoLegal.enlaces.descripcion'
            )}
          </p>
        </section>

        <section>
          <h2>
            {t(
              'avisoLegal.legislacion.titulo'
            )}
          </h2>

          <p>
            {t(
              'avisoLegal.legislacion.descripcion'
            )}
          </p>
        </section>
      </article>
    </main>
  );
}

export default AvisoLegal;